import { render, staticRenderFns } from "./EbookPage.vue?vue&type=template&id=377923c8"
import script from "./EbookPage.vue?vue&type=script&lang=js"
export * from "./EbookPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports